var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { forwardRef, useImperativeHandle } from "react";
import { BumpyFile } from "@propertyreach/bumpyfile-sdk";
import { createFileImport } from "./api";
import { buildBumpySession, getBumpyApiBaseUrl, getBumpyPublishableKey, submitDataColumnNames, } from "./bumpy";
var BumpyFileImporter = forwardRef(function (_a, ref) {
    var accountId = _a.accountId, userId = _a.userId, objectPrefix = _a.objectPrefix, onImported = _a.onImported, onError = _a.onError, onStart = _a.onStart, onDone = _a.onDone;
    function openPortal() {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onStart === null || onStart === void 0 ? void 0 : onStart();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, BumpyFile.openWithSession({
                                apiBaseUrl: getBumpyApiBaseUrl(),
                                publishableKey: getBumpyPublishableKey(),
                                session: buildBumpySession(accountId, userId, objectPrefix),
                                onSessionCreated: function () { },
                                onComplete: function (event, handle) { return __awaiter(_this, void 0, void 0, function () {
                                    var submitData, columnNames, fileImport, error_2;
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                                    return __generator(this, function (_k) {
                                        switch (_k.label) {
                                            case 0:
                                                _k.trys.push([0, 2, , 3]);
                                                submitData = ((_a = event.data) !== null && _a !== void 0 ? _a : {});
                                                columnNames = submitDataColumnNames(submitData);
                                                handle.updateProgress({
                                                    title: "Saving import",
                                                    message: "Creating SkipSherpa import...",
                                                    indeterminate: true,
                                                });
                                                return [4 /*yield*/, createFileImport({
                                                        originalFilename: (_c = (_b = submitData.submitOriginalFilename) !== null && _b !== void 0 ? _b : submitData.originalFilename) !== null && _c !== void 0 ? _c : null,
                                                        originalFileObjectKey: (_e = (_d = submitData.submitOriginalFileObjectKey) !== null && _d !== void 0 ? _d : submitData.originalFileObjectKey) !== null && _e !== void 0 ? _e : null,
                                                        finalFileObjectKey: (_g = (_f = submitData.submitFinalFileObjectKey) !== null && _f !== void 0 ? _f : submitData.finalFileObjectKey) !== null && _g !== void 0 ? _g : null,
                                                        rowCount: (_j = (_h = submitData.submitRowCount) !== null && _h !== void 0 ? _h : submitData.rowCount) !== null && _j !== void 0 ? _j : 0,
                                                        columnNames: columnNames,
                                                    })];
                                            case 1:
                                                fileImport = _k.sent();
                                                onImported(fileImport);
                                                handle.hideProgress();
                                                onDone === null || onDone === void 0 ? void 0 : onDone();
                                                return [3 /*break*/, 3];
                                            case 2:
                                                error_2 = _k.sent();
                                                handle.hideProgress();
                                                onError(error_2 instanceof Error ? error_2.message : String(error_2));
                                                onDone === null || onDone === void 0 ? void 0 : onDone();
                                                return [3 /*break*/, 3];
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); },
                                onClose: function () {
                                    onDone === null || onDone === void 0 ? void 0 : onDone();
                                },
                                onError: function (error) {
                                    onError(error instanceof Error
                                        ? error.message
                                        : "Something went wrong while opening BumpyFile");
                                    onDone === null || onDone === void 0 ? void 0 : onDone();
                                },
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        onError(error_1 instanceof Error ? error_1.message : "Something went wrong while opening BumpyFile");
                        onDone === null || onDone === void 0 ? void 0 : onDone();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    useImperativeHandle(ref, function () { return ({ openPortal: openPortal }); });
    return null;
});
export default BumpyFileImporter;
